import React from 'react';
import { compose } from 'redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Core components
import TableRow from 'components/core/table/TableRow';
import TableCell from 'components/core/table/TableCell';
import { TextButton } from 'components/core/Button';
// Models
import mProduct from 'models/product';
import mPermission from 'models/permission';
// Custom
import { listRowSpecsShape, profileDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'profiles/navigation';
import withLoading from 'hocs/WithLoading';
import { EditIconButton, DeleteIconButton } from 'components/buttons/IconButtons';
import TruncatedTooltipText from 'components/misc/TruncatedTooltipText';
import AppIcon from 'components/icons/AppIcon';

const ProfileProduct = ({ profile }) => {
  const product = mProduct.fromConfigurationValue(profile.product);

  if (product) {
    return (
      <div className="d-flex align-items-center">
        <AppIcon defaultColor id={product.icon} className="mr-2" />
        <TruncatedTooltipText>
          <LocalizedMessage id={product.labelId} />
        </TruncatedTooltipText>
      </div>
    );
  }
  return null;
};

ProfileProduct.propTypes = {
  profile: profileDataShape.isRequired,
};

const ProfileRow = React.forwardRef(({
  profile,
  rowSpecs,
  handleStartLoading,
  onDisplayPermissions,
  onDelete,
}, ref) => {
  const { id: profileId, permissions } = profile;

  /* We always need at least one unique profile with type set to 'bookings' (equivalent of having permissions strictly equal to ['bookings'])
  otherwise we can't access OPAC and CPM apps so we have to disable the ability to edit or delete this profile */
  const profileIsBookingsType = mPermission.hasOnlyBookingsPermission(permissions);

  // Handlers
  const handleDelete = () => {
    onDelete(profile);
  };

  return (
    <TableRow
      ref={ref}
      element={profile}
      rowSpecs={rowSpecs}
      actions={[
        <EditIconButton key="bEdit" disabled={profileIsBookingsType} onClick={handleStartLoading} path={showPath(profileId)} />,
        <DeleteIconButton key="bDelete" disabled={profileIsBookingsType} onClick={handleDelete} />,
      ]}
    >
      <TableCell>
        <TruncatedTooltipText>{profile.name}</TruncatedTooltipText>
      </TableCell>

      <TableCell>
        <ProfileProduct profile={profile} />
      </TableCell>
      <TableCell className="table-content-2" noPadding>
        <TextButton onClick={() => onDisplayPermissions(profile)} label={<LocalizedMessage id="button.display" />} />
      </TableCell>
    </TableRow>
  );
});

ProfileRow.displayName = 'ProfileRow';

ProfileRow.propTypes = {
  profile: profileDataShape.isRequired,
  rowSpecs: listRowSpecsShape.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
  onDisplayPermissions: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};

ProfileRow.defaultProps = {
  onDelete: null,
};

module.exports = compose(
  withLoading,
)(ProfileRow);



// WEBPACK FOOTER //
// ./routes/app/routes/profiles/assets/main/ProfileRow.js